const user = {
  state: {
    token:'',
    userInfo:{name:''}
  },
  actions: {
    // OAuth ({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     oAuth().then(response => {
    //       if(response.data.result){
    //         commit('SET_USER_INFO', response.data.data)
    //         commit('SET_TOKEN', response.data.data.token)
    //       }
    //       resolve(response.data.result)
    //     })
    //   })
    // },
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  namespaced: true
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js